/**
 * @generated SignedSource<<4ae3cb4ec30859673e52a53085ede35a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedCondensedSidebarButtons_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactDealerButton_user" | "PdpSharedMakeOfferButton_user" | "SharedSaveSearchContext_user">;
  readonly " $fragmentType": "PdpSharedCondensedSidebarButtons_user";
};
export type PdpSharedCondensedSidebarButtons_user$key = {
  readonly " $data"?: PdpSharedCondensedSidebarButtons_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedCondensedSidebarButtons_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedCondensedSidebarButtons_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedMakeOfferButton_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedSaveSearchContext_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f63d91cda9876faa27f2b18506b0db47";

export default node;
